import React from 'react';
import { Rating } from 'react-simple-star-rating';
import { useMediaQuery } from '../../hooks/mediaQuery';

interface RatingFieldProps {
  field: Record<string, any>;
  setFieldValue: (fieldName: string, value: any) => void;
}

export const RatingField = ({ field, setFieldValue }: RatingFieldProps) => {
  const mediaQuery = useMediaQuery(768);

  const { name, value } = field;
  const handleRate = (rate: number) => {
    setFieldValue(name, rate);
  };
  return (
    <Rating
      onClick={handleRate}
      initialValue={value > 0 ? value : 0}
      fillColor="orange"
      emptyColor="gray"
      SVGstyle={{ display: 'inline-block' }}
      allowFraction
      size={mediaQuery ? 25 : 35}
    />
  );
};
